/* unplugin-vue-components disabled */import script from "./HeaderViews.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderViews.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderViews.vue?vue&type=style&index=0&id=a7e8bd64&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7e8bd64"]])

export default __exports__